<template>
  <div class="chat_div">
    <div class="chat_ln">
      <div class="left" v-if="false">
        <div class="title">切换写作风格</div>
        <div
          class="list"
          :class="{ active: active == index }"
          @click="active = index"
          v-if="index < isGs"
          v-for="(item, index) in list"
          :key="index"
        >
          {{ item }}
        </div>
        <div class="gdsl" @click="isGs == 5 ? (isGs = 100) : (isGs = 5)">
          <i
            :class="isGs == 5 ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"
          ></i>
        </div>
      </div>
      <div class="right">
        <div class="engine-tab-wrap"></div>
        <!-- <div class="chat_ln_1" v-if="isMobile">
            <div class="box">
                <el-dropdown trigger="click" @command="handleCommandA">
                    <div class="button">
                        {{param.select_style}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="item" v-for="(item, index) in list" :key="index">{{item}}</el-dropdown-item>
                    
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div> -->
        <div class="chat_ln_2" ref="mianscroll" @scroll="handleScroll">
          <div class="list" v-for="(item, index) in listQuery" :key="index">
            <template v-if="item.divider">
              <div
                class="divider"
                :class="{ hiddenDot: item.text.startsWith('已选择') }"
              >
                <div class="text">{{ item.text }}</div>
              </div>
            </template>
            <template v-else>
              <!-- from YOU -->
              <div class="bubble-container bubble-me">
                <div class="bubble-main">
                  <div class="bubble-hd">
                    <div class="engine">
                      <div class="avatar">{{ account.username[0] }}</div>
                      你
                      <!-- {{ account.username }} -->
                    </div>
                  </div>
                  <div class="bubble-content">
                    <div
                      class="text"
                      v-html="
                        item.woTitle
                          .replace(/\n|\r\n/g, '<br>')
                          .replace(/ /g, '&nbsp;')
                      "
                    ></div>
                  </div>
                  <div class="bubble-bottom">
                    <div
                      class="attach"
                      v-for="item1 in item.files.filter(
                        (e) => e.type === 'doc'
                      )"
                    >
                      <img
                        class="icon"
                        src="@/assets/images/new/icon_doc_small.svg"
                      />
                      <span class="name">{{ cutFilename(item1.name) }}</span>
                    </div>
                    <div
                      class="attach"
                      v-for="item1 in item.files.filter(
                        (e) => e.type === 'image'
                      )"
                    >
                      <img class="icon" :src="item1.url" />
                      <span class="name">{{ cutFilename(item1.name) }}</span>
                    </div>
                    <div class="copy" @click="onCopy(item.woTitle)">
                      <img src="@/assets/images/new/copy.svg" /> 复制全文
                    </div>
                  </div>
                </div>
              </div>
              <!--from AI-->
              <div
                class="bubble-container bubble-ai"
                v-for="(item1, index1) in item.answers"
                :key="index1"
              >
                <div class="bubble-main">
                  <div class="bubble-hd">
                    <div class="engine">
                      <img :src="getEngineIcon(item1.engine)" />
                      {{ getEngineName(item1.engine) }}
                      <!-- <span class="version">{{ getEngineVersion(item1.engine) }}</span> -->
                      <div class="mode">
                        <el-tooltip content="联网模式" placement="top" v-if="item.web">
                          <img src="@/assets/images/new/icon_web.svg" />
                        </el-tooltip>
                        <el-tooltip content="GPT-4 Plus模式" placement="top" v-if="item.enhance">
                          <img src="@/assets/images/new/icon_enhance.svg" />
                        </el-tooltip>
                      </div>
                    </div>
                    <div class="action" v-if="item1.finished">
                      <div
                        class="probe"
                        @click="handleProbe(item1)"
                        v-if="
                          isLastQuery(item.index) && item.answers.length > 1
                        "
                      >
                        <img src="@/assets/images/new/msg.svg" /> 追问
                      </div>
                      <span v-else></span>
                      <div
                        class="copy"
                        @click="onCopy(item1.taTitle)"
                        v-if="item1.engine !== 'suno'"
                      >
                        <img src="@/assets/images/new/copy.svg" /> 复制全文
                      </div>
                    </div>
                  </div>
                  <div class="bubble-content">
                    <template v-if="item1.engine === 'suno'">
                      <div
                        class="audio-list"
                        v-if="item1.audio1 && item1.audio2"
                      >
                        <div class="audio-item">
                          <audio
                            controls
                            :src="item1.audio1"
                            @play="handleAudioPlay"
                          ></audio>
                        </div>
                        <div class="audio-item">
                          <audio
                            controls
                            :src="item1.audio2"
                            @play="handleAudioPlay"
                          ></audio>
                        </div>
                      </div>
                      <template v-else>
                        <mavon-editor
                          v-if="item1.taTitle"
                          class="md_box"
                          :value="item1.taTitle"
                          :subfield="prop.subfield"
                          :defaultOpen="prop.defaultOpen"
                          :toolbarsFlag="prop.toolbarsFlag"
                          :editable="prop.editable"
                          :scrollStyle="prop.scrollStyle"
                        />
                        <div class="loading-wrap" v-if="!item1.finished">
                          <!-- AI生成中... -->
                          <div class="loadingThree">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>
                        </div>
                      </template>
                    </template>
                    <template v-else>
                      <mavon-editor
                        v-if="item1.taTitle"
                        class="md_box"
                        :value="item1.taTitle"
                        :subfield="prop.subfield"
                        :defaultOpen="prop.defaultOpen"
                        :toolbarsFlag="prop.toolbarsFlag"
                        :editable="prop.editable"
                        :scrollStyle="prop.scrollStyle"
                      />
                      <div class="loading-wrap" v-else>
                        <!-- AI生成中... -->
                        <div class="loadingThree">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div class="bubble-bottom"></div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="chat_ln_3_fixed">
        <div class="engine-select-wrap">
          <EngineSelect
            v-model="engine"
            :docNum="chatDocs.length"
            :imageNum="chatImages.length"
            :webMode="param.web"
            :enhanceMode="param.enhance"
            multiple
            @input="handleEngineChange"
          />

          <template v-if="chatInputToolbarShow">
            <div class="chat-check chat-check-flex" v-if="!isMobile">
              <el-checkbox
                v-model="param.web"
                :true-label="1"
                :false-label="0"
                @change="handleNotSupportMode('web')"
                >联网模式</el-checkbox
              >
              <el-checkbox
                v-model="param.enhance"
                :true-label="1"
                :false-label="0"
                class="c1"
                @change="handleNotSupportMode('enhance')"
                >GPT-4 Plus模式</el-checkbox
              >
              <el-tooltip placement="top">
                <div slot="content">
                  开启后，效果与官网GPT-4 Plus会员一致，<br>支持DALL·E绘图、代码解释器等全部高级能力
                </div>
                <img src="@/assets/images/new/icon_question.svg" />
              </el-tooltip>
            </div>

            <el-popover
              placement="top-start"
              width="180"
              popper-class="engine-select-popover"
              :visible-arrow="false"
              v-if="isMobile"
            >
              <span slot="reference" class="chat-check-trigger"
                ><i class="el-icon-more"></i
              ></span>
              <ul class="chat-check chat-check-popup">
                <li>
                  <el-checkbox
                    v-model="param.web"
                    :true-label="1"
                    :false-label="0"
                    @change="handleNotSupportMode('web')"
                    >联网模式</el-checkbox
                  >
                </li>
                <li>
                  <div>
                    <el-checkbox
                      v-model="param.enhance"
                      :true-label="1"
                      :false-label="0"
                      class="c1"
                      @change="handleNotSupportMode('enhance')"
                      >GPT-4 Plus模式</el-checkbox
                    >
                    <el-tooltip placement="top">
                      <div slot="content">
                        将启动GPT-4-ALL，智能体模式，集成了官网Plus的<br />所有处理能力，包括语音、图像、代码解释器、插件等
                      </div>
                      <img src="@/assets/images/new/icon_question.svg" />
                    </el-tooltip>
                  </div>
                </li>
              </ul>
            </el-popover>
          </template>
          <template v-else>
            <div class="chat-check chat-check-flex" v-if="!isMobile">
              <el-switch
                v-model="param.makeInstrumental"
                inactive-text="纯音乐"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <div class="tags" v-if="!param.makeInstrumental">
                音乐风格
                <el-select v-model="param.tags">
                  <el-option
                    v-for="item in sunoTagList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <el-popover
              placement="top-start"
              width="180"
              popper-class="engine-select-popover"
              :visible-arrow="false"
              v-if="isMobile"
            >
              <span slot="reference" class="chat-check-trigger"
                ><i class="el-icon-more"></i
              ></span>
              <ul class="chat-check chat-check-popup">
                <li>
                  <div class="label">纯音乐</div>
                  <el-switch
                    v-model="param.makeInstrumental"
                    :active-value="1"
                    :inactive-value="0"
                  ></el-switch>
                </li>
                <li>
                  <div class="label">音乐风格</div>
                  <el-select v-model="param.tags">
                    <el-option
                      v-for="item in sunoTagList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </li>
              </ul>
            </el-popover>
          </template>
        </div>
        <div class="buts">
          <!-- <div class="but" @click="emptyFun(true)"><img src="@/assets/images/qcdh_icon.svg" class="icon" />清除对话</div>
            <div class="but" @click="oncemore()"><img src="@/assets/images/clear_button.svg" class="icon" />换个回答</div> -->
          <!-- <div class="but" @click="getEngineSavedialog()"><img src="@/assets/images/save.svg" class="icon" />保存对话</div> -->
          <el-button
            :disabled="isListQueryEmpty || isLoading"
            icon="el-icon-delete"
            @click="emptyFun(true)"
            >清除{{ isMobile ? "" : "对话" }}</el-button
          >
          <el-button
            :disabled="isListQueryEmpty || isLoading"
            icon="el-icon-document-checked"
            @click="getEngineSavedialog()"
            >保存{{ isMobile ? "" : "对话" }}</el-button
          >
        </div>

        <div class="chat_ln_3">
          <div class="chat-input-small" :class="{ 'is-focus': isFocus }">
            <div class="chat-input-inner">
              <div class="chat-input-textarea">
                <textarea
                  ref="chatInput"
                  class="textarea_input"
                  :value="param.query"
                  @focus="handleInputFocus"
                  @blur="isFocus = false"
                  @input="handleQueryInput"
                  @keydown.enter="exactA"
                  @paste="handleInputPaste($event)"
                  :placeholder="inputPlaceholder"
                ></textarea>
                <div
                  class="textarea_ghost"
                  v-html="formatTextToHtml(param.query)"
                ></div>
              </div>
              <div class="chat-input-button">
                <div class="chat-input-button-inner">
                  <div class="toolbar" v-if="chatInputToolbarShow">
                    <div
                      class="toolbar-item"
                      :class="{
                        disabled: chatImages.length,
                      }"
                    >
                      <div
                        class="upload-disabled-mask"
                        @click="handleNotSupportFile('doc')"
                        v-if="!account.pic_file_support || chatImages.length"
                      ></div>
                      <el-upload
                        action="https://codimdhk.floatai.cn/uploadimage"
                        name="image"
                        :show-file-list="false"
                        :before-upload="handleBeforeUpload"
                        :on-success="handleUploadSuccess"
                        :on-error="handleUploadError"
                        :on-exceed="()=>handleExceed(5)"
                        multiple
                        :limit="5"
                        :file-list="chatDocs"
                        accept=".txt, .js, .py, .html, .cs, .java, .go, .php, .xml, .yml, .yaml, .toml, .ini, .cfg, .conf, .sh, .bat, .css, .json, .csv, .md, .ts, .tsx, .jsx, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx,application/pdf"
                      >
                        <el-tooltip
                          content="支持.pdf、.docx、.xlsx、.pptx、.txt、.py等数十种文档类型，大小不超过10MB"
                        >
                          <img src="@/assets/images/new/icon_file.svg" @click="handleFocusout" />
                        </el-tooltip>
                      </el-upload>
                    </div>
                    <div
                      class="toolbar-item"
                      :class="{
                        disabled: chatDocs.length,
                      }"
                    >
                      <div
                        class="upload-disabled-mask"
                        @click="handleNotSupportFile('image')"
                        v-if="!account.pic_file_support || chatDocs.length"
                      ></div>
                      <el-upload
                        action="https://codimdhk.floatai.cn/uploadimage"
                        name="image"
                        :show-file-list="false"
                        :before-upload="handleBeforeUpload"
                        :on-success="handleUploadSuccess"
                        :on-error="handleUploadError"
                        :on-exceed="()=>handleExceed(10)"
                        multiple
                        :limit="10"
                        :file-list="chatImages"
                        accept=".png,.jpg,.jpeg,.bmp,.webp"
                      >
                        <el-tooltip
                          content="支持png、jpg类型文件，大小不超过5MB"
                        >
                          <img src="@/assets/images/new/icon_img.svg" @click="handleFocusout" />
                        </el-tooltip>
                      </el-upload>
                    </div>
                  </div>

                  <div class="button_box">
                    <img
                      class="fs_button"
                      @click="getMultiEngineQuery()"
                      src="@/assets/images/new/enter.svg"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="filebox" v-if="chatFiles.length">
              <div class="filebox-doc">
                <div class="item" v-for="item in chatDocs" :key="item.uid">
                  <a
                    href=""
                    class="del"
                    @click.prevent="handleRemove(item)"
                  ></a>
                  <div class="file" v-loading="item.isUploading">
                    <img
                      src="@/assets/images/new/icon_file1.svg"
                      class="icon"
                    />
                    <div class="info">
                      <p>{{ cutFilename(item.name) }}</p>
                      <p>{{ item.fileExt }}，{{ item.fileSize }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="filebox-image">
                <div class="item" v-for="item in chatImages" :key="item.uid">
                  <a
                    href=""
                    class="del"
                    @click.prevent="handleRemove(item)"
                  ></a>
                  <div class="image" v-loading="item.isUploading">
                    <img :src="item.url" />
                  </div>
                </div>
              </div>
            </div>
            <div class="ms">Shift+Enter输入框内换行</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EngineSelect from "../../components/EngineSelect.vue";
import {
  apiUpload,
  apiCheckSession,
  payAccountcheck,
  logout,
  engineSavedialog,
  apiCreateSuno,
  apiFetchSuno,
} from "@/api";
import {
  cutFilename,
  fixEngineValues,
  getEngineObj,
  getEngineIcon,
  getEngineName,
  getEngineVersion,
  getFileSize,
} from "../../utils/utils";
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";
import axios from "axios";
import { sunoTagList } from "@/constants";

// var t = document.getElementById("left");
// t.style.visibility = 'hidden'
// document.getElementById("left").style.visibility="hidden"
export default {
  components: {
    // 在页面中注册组件
    mavonEditor,
    EngineSelect,
  },
  data() {
    return {
      active: 0,
      list: [
        "无风格(默认)",
        "小学生",
        "科技文",
        "猫猫语",
        "跨语言",
        "其他自己放",
        "其他自己放",
        "其他自己放",
        "其他自己放",
        "其他自己放",
        "其他自己放",
        "其他自己放",
        "其他自己放",
      ],
      isGs: 5,
      value: "",

      param: {
        select_style: "无风格（默认）",
        select_lang: "简体中文（默认）",
        query: "",
        ask_again: 0,
        new_session: 1,
        engine: "", // claude, gpt
        files: [],
        images: [],
        web: 0,
        enhance: 0,
        makeInstrumental: 0,
        tags: "",
      },
      historychat: {
        woTitle: [],
        taTitle: [],
      },
      listQuery: [],
      askCount: 0,
      isLoading: false, //是否正在生成

      account: {},
      lastquery: "",
      chatFiles: [],
      isUploading: false,
      engine: [],
      scrollable: true,
      scrollTop: 0,
      engineMap: {},
      isFocus: false,
      queryCount: 0,
      sunoFetchTimer: null,
      sunoTagList,
    };
  },
  computed: {
    isListQueryEmpty() {
      var that = this;
      return that.listQuery.length === 0;
    },
    inputPlaceholder() {
      if (this.engine.length) {
        return `正在提问${this.engine
          .map((e) => this.getEngineName(e))
          .join("、")}，${
          this.engine[0] === "suno"
            ? this.param.makeInstrumental
              ? "请输入纯音乐风格，不超过100字"
              : "请输入歌词，不超过1200字"
            : "请输入问题"
        }`;
      }
      return `请先选择至少一个要提问的AI，再输入问题`;
    },
    chatInputToolbarShow() {
      return this.engine?.[0] !== "suno";
    },
    chatInputMaxLength() {
      if (this.engine?.[0] === "suno") {
        return this.param.makeInstrumental ? 100 : 1200;
      }
      return -1;
    },
    chatDocs() {
      return this.chatFiles.filter((e) => e.type === "doc");
    },
    chatImages() {
      return this.chatFiles.filter((e) => e.type === "image");
    },
    prop() {
      let data = {
        subfield: false, // 单双栏模式
        defaultOpen: "preview", //edit： 默认展示编辑区域 ， preview： 默认展示预览区域
        editable: false, // 是否允许编辑
        toolbarsFlag: false,
        scrollStyle: true,
      };
      return data;
    },
  },
  watch: {
    "listQuery.length"(val) {
      // this.scrollToBottom()
    },
  },
  mounted() {
    var that = this;
    that.getPayAccountcheck();
  },
  beforeDestroy() {
    clearInterval(this.sunoFetchTimer);
  },
  methods: {
    // 保存对话
    getEngineSavedialog() {
      var that = this;
      const session_ids = Object.values(this.engineMap).map(
        (e) => e.session_id
      );
      console.log(session_ids);
      // 如果没有提示过，则弹出提示弹窗
      if (!localStorage.getItem("prompted")) {
        that
          .$confirm(`请在右上角查看历史对话。`, "提示", {
            confirmButtonText: "知道了",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            localStorage.setItem("prompted", true); // 设置为已提示
            engineSavedialog({ session_ids }).then((res) => {
              if (res.code == 0) {
                that.$message.success("保存成功");
              }
            });
          })
          .catch(() => {});
      } else {
        // 否则在保存后直接存储状态，以便下次使用
        localStorage.setItem("prompted", true);
        engineSavedialog({ session_ids }).then((res) => {
          if (res.code == 0) {
            that.$message.success("保存成功");
          }
        });
      }
    },

    guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },

    //清空会话
    emptyFun(is) {
      var that = this;
      let scrollEl = this.$refs.mianscroll;
      if (is) {
        that
          .$confirm("是否清除对话", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            that.listQuery = [];
            that.param = {
              select_style: "无风格（默认）",
              select_lang: "简体中文（默认）",
              query: "",
              new_session: 1,
              engine: "",
              files: [],
              images: [],
            };
            this.engineMap = {};
            scrollEl.scrollTo({ top: 0, behavior: "instant" });
          })
          .catch(() => {});
      } else {
        that.listQuery = [];
        that.param = {
          select_style: "无风格（默认）",
          select_lang: "简体中文（默认）",
          query: "",
          new_session: 1,
          engine: "",
          files: [],
          images: [],
        };
        this.engineMap = {};
        scrollEl.scrollTo({ top: 0, behavior: "instant" });
      }
    },
    //复制
    onCopy(text) {
      var that = this;
      this.$copyText(text).then(
        (e) => {
          that.$message.success("复制成功");
        },
        (e) => {
          that.$message.error("复制失败");
        }
      );
    },
    //
    handleProbe({ engine }) {
      this.engine = [engine];
      if (this.listQuery[this.listQuery.length - 1].divider) {
        this.listQuery[
          this.listQuery.length - 1
        ].text = `已选择${this.getEngineName(engine)}`;
      } else {
        this.listQuery.push({
          divider: true,
          text: `已选择${this.getEngineName(engine)}`,
        });
      }
      this.$refs.chatInput.focus();
      this.scrollToBottom();
      // 清除图片和复选框
      const engineObj = getEngineObj(engine);
      if (!engineObj.docSupport && this.chatDocs.length) {
        this.chatFiles = this.chatFiles.filter((e) => e.type !== "doc");
      }
      if (!engineObj.imageSupport && this.chatImages.length) {
        this.chatFiles = this.chatFiles.filter((e) => e.type !== "image");
      }
      if (!engineObj.webMode) {
        this.param.web = 0;
      }
      if (!engineObj.enhanceMode) {
        this.param.enhance = 0;
      }
    },
    handleEngineChange() {
      const msg = this.listQuery[this.listQuery.length - 1];
      if (msg?.divider && msg?.text.startsWith("已选择")) {
        this.listQuery.splice(this.listQuery.length - 1, 1);
      }
      this.checkSession();
    },
    handleInputFocus() {
      this.isFocus = true;
      this.checkSession();
    },
    exactA(e) {
      var that = this;
      if (e.keyCode == 13 && e.ctrlKey) {
        that.param.query += "\n"; //换行
      } else if (e.keyCode == 13 && e.shiftKey) {
        that.value += "\n"; //换行
      } else if (e.keyCode == 13) {
        that.getMultiEngineQuery();
        e.preventDefault(); //禁止回车的默认换行
      }
    },
    getEngineIcon,
    getEngineName,
    getEngineVersion,
    handleScroll(e) {
      if (this.scrollTop - e.target.scrollTop > 10 && this.isLoading) {
        console.log("scrollable", false);
        this.scrollable = false;
      }
      this.scrollTop = e.target.scrollTop;
    },
    scrollToBottom(force = true) {
      if (force || this.scrollable) {
        console.log("scrollToBottom");
        const scrollEl = this.$refs.mianscroll;
        this.$nextTick(function () {
          scrollEl?.scrollTo({
            top: scrollEl.scrollHeight,
            behavior: "instant",
          });
        });
      }
    },
    isLastQuery(index) {
      return index === this.listQuery.filter((e) => !e.divider).length - 1;
    },
    async checkSession() {
      const requestList = [];

      for (const engine of this.engine) {
        const session_id = this.engineMap[engine]?.session_id;
        const new_session = this.engineMap[engine]?.new_session;
        if (session_id && new_session === 0) {
          requestList.push(
            new Promise((resolve) => {
              apiCheckSession({
                session_id,
                engine,
              })
                .then((res) => {
                  if (res.code === 10) {
                    this.engineMap[engine].new_session = 1;
                    this.engineMap[engine].session_id = this.guid();
                    resolve(engine);
                  } else {
                    resolve(null);
                  }
                })
                .catch((e) => resolve(null));
            })
          );
        }
      }

      return Promise.all(requestList).then((values) => {
        console.log("expiredList : ", values);
        const expiredList = values.filter((e) => e);
        if (expiredList.length) {
          this.listQuery.push({
            divider: true,
            text: `${expiredList
              .map((e) => this.getEngineName(e))
              .join("、")}对话已过期，开始新对话`,
          });
          this.scrollToBottom();
        }
      });
    },
    // 全局状态：isLoading，askCount，会话过期
    // 单个请求状态：超时
    async getMultiEngineQuery() {
      if (this.isLoading) {
        return;
      }
      if (this.askCount > 0) {
        return;
      }
      if (!this.engine.length) {
        this.$message.warning('请至少选择一个AI')
        return;
      }
      if (!this.param.query) {
        this.$message.warning('请输入问题')
        return;
      }
      if (
        this.chatInputMaxLength > 0 &&
        this.param.query.length > this.chatInputMaxLength
      ) {
        this.$message.warning(`字数不能超过${this.chatInputMaxLength}字`);
        return;
      }
      if (this.chatFiles.filter(e => e.isUploading).length) {
        this.$message.warning('文件上传中，请稍后')
        return;
      }
      if (this.account.remain_requests < this.engine.length) {
        this.$confirm("剩余额度不足，请充值次数后继续使用", "提示", {
          confirmButtonText: "去充值",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }).then(() => {
          this.$router.push("/my");
        });
        return;
      }

      this.isLoading = true;
      this.scrollable = true;
      this.askCount = this.engine.length;
      // 记录历史
      this.listQuery.push({
        index: this.queryCount,
        woTitle: this.param.query,
        files: [...this.chatFiles],
        web: this.param.web,
        enhance: this.param.enhance,
        answers: [],
      });
      // 并发请求
      for (const e of this.engine) {
        this.getEngineQuery(e);
      }
      //清空操作
      this.queryCount++;
      this.scrollToBottom();
      this.param.query = "";
      this.chatFiles = [];
    },
    handleOneQueryEnd() {
      this.askCount--;
      // 全部结束
      if (this.askCount === 0) {
        console.log("所有query完成");
        this.isLoading = false;
        this.scrollToBottom(false);
        this.scrollable = true;
        payAccountcheck().then((res) => {
          if (res.code == 0) {
            this.account = res.result;
          }
        });
      }
    },
    getEngineQuery(engine) {
      if (this.account.multi_turn && !this.engineMap[engine]) {
        this.engineMap[engine] = {
          new_session: 1,
          session_id: this.guid(),
        };
      }

      if (engine === "suno" && this.engineMap[engine]) {
        this.engineMap[engine].session_id = this.guid();
      }

      this.listQuery[this.listQuery.length - 1].answers.push({
        taTitle: "",
        engine,
        finished: false,
        //suno特有
        audio1: "",
        audio2: "",
      });

      const curQueryIndex = this.listQuery.length - 1;
      const curAnswerIndex = this.listQuery[curQueryIndex].answers.length - 1;

      const curParam = { ...this.param };
      curParam.engine = engine;
      curParam.files = this.chatFiles
        .filter((e) => e.type === "doc")
        .map((e) => e.url);
      curParam.images = this.chatFiles
        .filter((e) => e.type === "image")
        .map((e) => e.url);

      if (this.account.multi_turn) {
        curParam.new_session = this.engineMap[engine].new_session;
        curParam.session_id = this.engineMap[engine].session_id;
      }

      if (engine === "suno") {
        this.sendSunoQuery(curParam, curQueryIndex, curAnswerIndex);
      } else {
        this.sendCommonQuery(curParam, curQueryIndex, curAnswerIndex);
      }
    },
    sendCommonQuery(params, queryIndex, answerIndex) {
      const engine = params.engine;
      const that = this;
      let curCount = 0; //超时计数？
      const totalCount =
        params.files.length || params.images.length || params.web ? 180 : 30;
      let curTimer = window.setInterval(() => {
        if (curCount >= totalCount) {
          this.listQuery[queryIndex].answers[answerIndex].taTitle +=
            "\n【系统提示：请求超时，请重试】";
          clearInterval(curTimer);
          this.handleOneQueryEnd();
        } else {
          curCount++;
        }
      }, 1000);

      axios({
        url: "api/engine/query",
        method: "post",
        responseType: "stream",
        headers: {
          "Content-Type": "application/json;",
        },
        data: params,
        onDownloadProgress: function (res) {
          curCount = 1;
          that.listQuery[queryIndex].answers[answerIndex].taTitle =
            res.currentTarget.response;
          that.scrollToBottom(false);
        },
      })
        .then((res) => {
          console.log(engine, this.askCount, res);
          clearInterval(curTimer);
          that.listQuery[queryIndex].answers[answerIndex].finished = true;
          // 会话已过期
          if (res.data.code == 30) {
            that.listQuery[queryIndex].answers[answerIndex].taTitle =
              "对话已过期，开始新对话";
            this.engineMap[engine].new_session = 1;
            this.engineMap[engine].session_id = this.guid();
            return;
          } else if (res.data.code == 40) {
            // 登录失效
            that.listQuery[queryIndex].answers[answerIndex].taTitle =
              res.data.result.message;
            that.$alert(res.data.result.message, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                //去登录
                logout().then((res) => {
                  if (res.code == 0) {
                    that.$router.push({ path: "/login" });
                  }
                });
              },
            });
            return;
          } else if (res.data.code == 405 || res.data.code == 10) {
            that.$message.error(res.data.result.message);
            that.listQuery[queryIndex].answers[answerIndex].taTitle =
              res.data.result.message;
          }
          if (this.account.multi_turn) {
            this.engineMap[engine].new_session = 0;
          }
          this.handleOneQueryEnd();
        })
        .catch((error) => {
          console.log(error);
          clearInterval(curTimer);
          this.handleOneQueryEnd();
          if (error.response?.status == 401) {
            that.$router.push({
              path: "/login",
            });
          }
        });
    },
    async sendSunoQuery(params, queryIndex, answerIndex) {
      const { code, result: nextParam } = await apiCreateSuno(
        params.session_id
          ? params
          : { ...params, session_id: this.guid(), new_session: 1 }
      );
      const startTime = Date.now() / 1000;
      const doFetchSuno = async () => {
        if (Date.now() / 1000 - startTime < 150) {
          return;
        }
        const { result } = await apiFetchSuno(nextParam);
        console.log(result);
        if (result.audio_url1 && result.audio_url2) {
          this.listQuery[queryIndex].answers[answerIndex].finished = true;
          this.listQuery[queryIndex].answers[answerIndex].audio1 =
            result.audio_url1;
          this.listQuery[queryIndex].answers[answerIndex].audio2 =
            result.audio_url2;
          this.handleOneQueryEnd();
          clearInterval(this.sunoFetchTimer);
        }
      };
      const doFetchSunoInterval = () => {
        clearInterval(this.sunoFetchTimer);
        this.sunoFetchTimer = setInterval(doFetchSuno, 20 * 1000);
      };
      if (code === 0) {
        this.listQuery[queryIndex].answers[answerIndex].taTitle =
          nextParam.message || "请稍后...";
        doFetchSunoInterval();
      } else {
        this.listQuery[queryIndex].answers[answerIndex].finished = true;
        this.listQuery[queryIndex].answers[answerIndex].taTitle =
          nextParam.message;
        this.handleOneQueryEnd();
        if (code === 11) {
          this.$confirm(
            "免费套餐仅支持试用1次Suno音乐生成，升级VIP畅享海量生成",
            "提示",
            {
              confirmButtonText: "去升级",
              cancelButtonText: "暂不升级",
              type: "warning",
              center: true,
            }
          ).then(() => {
            this.$router.push("/my");
          });
        }
      }
    },
    getPayAccountcheck() {
      var that = this;
      payAccountcheck().then(async (res) => {
        if (res.code == 0) {
          that.account = res.result;

          that.param.query = localStorage.getItem("chatValue") || "";
          that.param.web = +localStorage.getItem("chatWebMode");
          that.param.enhance = +localStorage.getItem("chatEnhanceMode");
          that.param.makeInstrumental =
            +localStorage.getItem("makeInstrumental");
          that.param.tags = localStorage.getItem("sunoTags") || "pop";
          const engine = JSON.parse(localStorage.getItem("chatEngine") || "[]");
          const tempFiles = JSON.parse(
            localStorage.getItem("chatFiles") || "[]"
          );
          this.engine = fixEngineValues(engine);
          this.chatFiles = [...tempFiles];

          if (that.param.query) {
            localStorage.setItem("chatValue", "");
            localStorage.setItem("chatFiles", "");
            localStorage.setItem("chatWebMode", "");
            localStorage.setItem("chatEnhanceMode", "");
            localStorage.setItem("makeInstrumental", "");
            localStorage.setItem("sunoTags", "");
            await that.getMultiEngineQuery();
            that.engine = that.engine.slice(0, 1);
          }
        }
      });
    },
    handleCommandA(command) {
      var that = this;
      that.param.select_style = command;
    },
    handleCommandB(command) {
      var that = this;
      that.param.select_lang = command;
    },
    // add by rich
    handleNotSupportFile(type) {
      if (!this.account.pic_file_support) {
        this.$confirm(
          "免费试用套餐不支持图片、文件上传，请升级为正式套餐。",
          "提示",
          {
            confirmButtonText: "去升级",
            cancelButtonText: "暂不升级",
            type: "warning",
            center: true,
          }
        ).then(() => {
          this.$router.push("/my");
        });
      }
      if (
        (type === "doc" && this.chatImages.length) ||
        (type === "image" && this.chatDocs.length)
      ) {
        this.$message.warning("文件和图片不可同时上传");
      }
    },
    handleNotSupportMode(mode) {
      // console.log(this.account.account_type)
      if (this.account.account_type === "免费试用") {
        let modeText;
        if (mode === "web") {
          this.param.web = 0;
          modeText = "联网模式";
        } else {
          this.param.enhance = 0;
          modeText = "GPT-4 Plus模式";
        }
        this.$confirm(
          `免费试用套餐不支持开启${modeText}，请升级为正式套餐。`,
          "提示",
          {
            confirmButtonText: "去升级",
            cancelButtonText: "暂不升级",
            type: "warning",
            center: true,
          }
        ).then(() => {
          this.$router.push("/my");
        });
      }
    },
    handleBeforeUpload(file) {
      const fileExt = file.name
        .substr(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      const fileType = file.type.startsWith("image/") ? "image" : "doc";
      const sizeLimit = fileType === "image" ? 5 : 10;
      if (
        ![
          "txt",
          "js",
          "py",
          "html",
          "cs",
          "java",
          "go",
          "php",
          "xml",
          "yml",
          "yaml",
          "toml",
          "ini",
          "cfg",
          "conf",
          "sh",
          "bat",
          "css",
          "json",
          "csv",
          "md",
          "ts",
          "tsx",
          "jsx",
          "pdf",
          "doc",
          "docx",
          "xls",
          "xlsx",
          "ppt",
          "pptx",
          "png",
          "jpg",
          "jpeg",
          "bmp",
          "webp",
        ].includes(fileExt)
      ) {
        this.$message.warning("文件格式不支持");
        return false;
      }
      if (file.size > sizeLimit * 1024 * 1024) {
        this.$message.warning(`文件大小不能超过${sizeLimit}M`);
        return false;
      }

      this.chatFiles.push({
        type: fileType,
        name: file.name,
        uid: file.uid,
        isUploading: true,
        fileExt,
        fileSize: getFileSize(file.size),
      });

      return true;
    },
    handleUploadSuccess(res, file) {
      this.chatFiles.forEach((e) => {
        if (e.uid == file.uid) {
          e.url = res.link;
          e.isUploading = false;
        }
      });
    },
    handleUploadError(err, file) {
      const index = this.chatFiles.findIndex((e) => e.uid == file.uid);
      if (index > -1) {
        this.chatFiles.splice(index, 1);
      }
      this.$message.warning(`上传失败，请重试`);
    },
    handleExceed(limit) {
      this.$message.warning(`最多上传${limit}个文件`);
    },
    handleRemove(item) {
      const index = this.chatFiles.findIndex((e) => e.uid == item.uid);
      if (index > -1) {
        this.chatFiles.splice(index, 1);
      }
    },
    handleInputPaste(e) {
      if (!(e.clipboardData && e.clipboardData.items)) {
        return;
      }
      [...e.clipboardData.items].forEach((item) => {
        if (item.kind === "file") {
          const file = item.getAsFile();
          this.uploadFile(file);
        }
      });
    },
    async uploadFile(file) {
      if (!this.account.pic_file_support) {
        this.$confirm(
          "免费试用套餐不支持图片、文件上传，请升级为正式套餐。",
          "提示",
          {
            confirmButtonText: "去升级",
            cancelButtonText: "暂不升级",
            type: "warning",
            center: true,
          }
        ).then(() => {
          this.$router.push("/my");
        });
        return false;
      }
      if (!file.type.startsWith("image/")) {
        return;
      }

      const fileUid = Date.now();

      this.chatFiles.push({
        type: file.type.startsWith("image/") ? "image" : "doc",
        name: file.name,
        uid: fileUid,
        isUploading: true,
      });

      const formData = new FormData();
      formData.append("image", file);
      const { data } = await apiUpload(formData);
      this.chatFiles.forEach((e) => {
        if (e.uid == fileUid) {
          e.url = data.link;
          e.isUploading = false;
        }
      });
    },
    cutFilename,
    handleQueryInput(e) {
      this.param.query = e.target.value;
    },
    formatTextToHtml(value) {
      return value
        .replace(/(\n|\r\n)$/, "<br>&nbsp;")
        .replace(/\n|\r\n/g, "<br>")
        .replace(/ /g, "&nbsp;");
    },
    handleAudioPlay(event) {
      document.querySelectorAll("audio").forEach((el) => {
        if (!el.paused && event.target != el) {
          el.pause();
        }
      });
    },
    handleFocusout() {
      const ta = document.querySelector('textarea')
      ta.focus()
      setTimeout(() => {
        ta.blur()
      }, 0)
    }
  },
};
</script>
<style lang="less" scoped>
.engine-tab-wrap {
  max-width: 1090px;
  margin: 0 auto 15px;
}
.engine-select-wrap {
  position: absolute;
  top: 5px;
  left: 39px;
  display: flex;
  align-items: center;
  .engine-select {
    margin-right: 20px;
  }
}
.bubble-container {
  display: flex;
  // margin-bottom: 10px;
}
.bubble-main {
  position: relative;
  max-width: 100%;
  flex: 1;
}
.bubble-hd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  .engine {
    margin-right: 10px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #232d36;
    font-weight: 500;
    img {
      width: 28px;
      margin-right: 14px;
    }
    .avatar {
      background-color: #7856e3;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      text-align: center;
      line-height: 28px;
      margin-right: 14px;
    }
  }
  .version {
    border: 1px solid #989a9d;
    border-radius: 4px;
    padding: 0 6px;
    font-size: 14px;
    color: #76787d;
    margin-left: 7px;
  }
  .mode {
    margin-left: 10px;
    height: 24px;
    img {
      margin-left: 8px;
      margin-right: 0;
      width: 24px;
    }
  }
  .action {
    flex: 1;
    display: flex;
    height: 22px;
    justify-content: space-between;
  }
}
.bubble-content {
  margin-left: 42px;
  margin-bottom: 5px;
  .text {
    word-break: break-word;
  }
}
.bubble-ai .bubble-content {
  margin-left: 27px;
  background: #f1f1f1;
  padding: 10px 15px;
  border-radius: 8px;
  min-height: 30px;
}
.bubble-bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 22px;
  margin-left: 42px;
}
.bubble-ai .bubble-bottom {
  min-height: 7px;
  height: 7px;
}

.loading-wrap {
  height: 35px;
}

.attach {
  margin-right: 10px;
  background: #f1f1f1;
  border-radius: 2px;
  display: flex;
  align-items: center;
  height: 22px;
  padding: 0 12px 0 4px;
  .icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .name {
    color: #989a9d;
    font-size: 14px;
  }
}
.copy {
  display: none;
  align-items: center;
  cursor: pointer;
  color: #6b6f6d;
  font-size: 14px;
  img {
    margin-right: 6px;
  }
}
.probe {
  background: linear-gradient(90deg, #f48e45 0%, #ff6199 100%);
  width: 64px;
  height: 24px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  display: none;
  img {
    width: 14px;
    height: 14px;
    margin-right: 6px;
  }
}

.bubble-container:hover .copy {
  display: flex;
}
.bubble-container:hover .probe {
  display: flex;
}

.audio-list {
  padding-top: 10px;
}
.audio-item {
  margin-bottom: 10px;
  audio {
    width: 95%;
    max-width: 300px;
    height: 45px;
  }
  audio::-webkit-media-controls-panel {
    background-color: #fff;
  }
}

@media only screen and (max-width: 610px) {
  .engine-select-wrap {
    left: 15px;
    .engine-select {
      margin-right: 10px;
    }
  }
  .bubble-hd {
    margin-bottom: 0;
  }
  .bubble-hd .engine {
    font-size: 14px;
    margin-right: 10px;
  }
  .bubble-hd .version {
    font-size: 12px;
  }
  .bubble-hd .mode {
    height: 18px;
    margin-left: 0;
    img {
      width: 18px;
    }
  }
  .bubble-content {
    font-size: 14px;
  }
  .bubble-bottom {
    height: auto !important;
  }
  .bubble-bottom .copy {
    display: none !important;
  }
  .probe,
  .copy {
    font-size: 12px;
  }
  .probe {
    width: 54px;
    height: 20px;
  }
}
</style>
